import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const LeadDataAPI = async (setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/leads?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setLeads(response.data.data.data);
        setLoading(false);
        setShowLeads(false);

        if(response.data.data.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}

export const getDispositionAPI = async (setDispositions, setLoading) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/setting/disposition");

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setDispositions(response.data.data);
        setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}

export const getSubDispositionAPI = async (dispositionid, setSubDispositions) =>
{
    //setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/setting/subdisposition/" + dispositionid);

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setSubDispositions(response.data.data);
        //setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }
}

export const editLeadAPI = async (leadid, setTxtName, setTxtEmail, setTxtContact, setTxtOtherContact, setTxtLocation, setTxtDisposition, setTxtSubDisposition, setScheduleDate, setScheduleTime, setTxtRemarks, setLoading) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/lead/edit/" + leadid);

        //console.log("Data got successfully", response.data);
        
        setTxtName(response.data.data.name);
        setTxtEmail(response.data.data.email);
        setTxtContact(response.data.data.contact);
        setTxtLocation(response.data.data.location);

        if(response.data.data.leadinfodata !==  null)
        {
            setTxtOtherContact(response.data.data.leadinfodata.alternate_contact);        
            setTxtDisposition(response.data.data.leadinfodata.disposition_id);
            setTxtSubDisposition(response.data.data.leadinfodata.subdisposition_id);
            setTxtRemarks(response.data.data.data.source);
        }

        if(response.data.data.notificationdata !== null)
        {
            setScheduleDate(response.data.data.notificationdata.display_date);
            setScheduleTime(response.data.data.notificationdata.display_time);
        }
            
        setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}

export const updateLeadDataAPI = async (params, setBtnLoading, navigate) =>
{
    setBtnLoading(true);

    try
    {
        const response = await baseapi.post("/api/admin/lead/update", params);

        //console.log("Data got successfully", response);
        
        if(response.data.code == 200)
        {
            successMesg("Lead has been updated successfully");

            navigate('/admin/leads');
        }
        else
        {
            errorMesg("Lead has not been updated. Please try again!!!");
        }
        
        setBtnLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setBtnLoading(false);
        errorMesg("Lead has not been updated. Please try again!!!");
    }
}

export const UploadCSVLeadAPI = async (formData, setBtnLoader, setIsUploaded, resetUserForm, setShowPopup, setFileList) =>
{
    setBtnLoader(true);

    try
    {
        const response = await baseapi.post("/api/admin/lead/upload", formData, {headers: {'Content-Type': 'multipart/form-data'}});

        //console.log("Data got successfully", response);

        setShowPopup(false);
        
        if(response.data.code == 200)
        {
            successMesg(response.data.mesg);

            //navigate('/sales/leads');

            resetUserForm();

            setIsUploaded(true);

            setFileList(response.data.uploadedlist.data);

        }
        else
        {
            errorMesg("Lead has not been updated. Please try again!!!");
        }
        
        setBtnLoader(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setBtnLoader(false);
        errorMesg("Lead has not been updated. Please try again!!!");
    }
}

export const getUploadedCSVListAPI = async (setFileList, setLoading, setPageCount, currentPage, perpagedata, setCampaignList) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/lead/uploaded-list?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.campaignlist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setFileList(response.data.datalist.data);
        setCampaignList(response.data.campaignlist);
        setLoading(false);

        if(response.data.datalist.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.datalist.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}


